import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

export const headingStyles: RichtextAdapterProps["customStyles"] = {
  heading: {
    mb: { base: 2, lg: 0 },
  },
  link: {
    fontSize: "lg",
    _visited: {},
  },
};
